export default __webpack_public_path__ + "static/media/interaction12.bf9c7ba7.png";